export default __webpack_public_path__ + "static/media/endodontic.d6d57514.svg";